<app-loading-status *ngIf="loaderService.isLoading | async; else notLoading"></app-loading-status>
<app-alert-status *ngIf="loadingError" [loadingError]="loadingError"></app-alert-status>

<ng-template #notLoading>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-11 col-12">
        <div class="row align-items-end mt-5 mb-3">
          <div class="col-md-7 col-12" *ngIf="layout">
            <app-area-heading [heading]="layout.heading" [subheading]="layout.subheading"
              [backRoute]="layout.backRoute"></app-area-heading>
          </div>

          <div class="col-md-5 col-12 d-flex mt-3 mt-md-0">
            <div class="ml-auto">
              <app-year-select (emitCurrentYear)="yearChange($event)"></app-year-select>
            </div>
          </div>
        </div>
        <app-dynamic-table *ngIf="currentProductInfo && productOrganisationList"
          [data]="productOrganisationList"
          [columns]="organisationTableColumns"
          [tableTitle]="currentProductInfo.productName + ' Export'"
          [primaryKey]="'organisationId'"
          [defaultGroupedColumn]="'pastOrFuture'"
          [onRowClick]="onTableClick">
        </app-dynamic-table>
      </div>
    </div>
  </div>
</ng-template>
